module.exports = __webpack_public_path__ + "static/media/placeholder_notifications.631e0966.svg";